module.exports = __webpack_public_path__ + "img/logo.cdac1bd8.png";